import { TabViewModule } from 'primeng/tabview';
import { PaginatorModule } from 'primeng/paginator';
import { TableModule } from 'primeng/table';
import { CheckboxModule } from 'primeng/checkbox';
import { ToastModule } from 'primeng/toast';
import { DataViewModule } from 'primeng/dataview';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { InputNumberModule } from 'primeng/inputnumber';
import { FieldsetModule } from 'primeng/fieldset';
import { Swiper } from 'swiper';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SharedModule } from './../shared/shared.module';

import { SwiperModule } from 'swiper/angular';

import { IndexComponent } from './index/index.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { HumanRecruitComponent } from './groupbreaks/human-recruit/human-recruit.component';
import { GroupBreakListComponent } from './groupbreaks/group-break-list/group-break-list.component';
import { GroupBreakDetailComponent } from './groupbreaks/group-break-detail/group-break-detail.component';
import { MagneticCaseComponent } from './merch/magnetic-case/magnetic-case.component';


import { SignUpComponent } from './sign/sign-up/sign-up.component';
import { SignInComponent } from './sign/sign-in/sign-in.component';
import { SecondTeamsFormComponent } from './groupbreaks/second-teams-form/second-teams-form.component';
import { MyAccountComponent } from './member/my-account/my-account.component';
import { SignUpCallbackComponent } from './sign-up-callback/sign-up-callback.component';

@NgModule({
	imports: [
		CommonModule,
		BrowserModule,
		FormsModule,
		RouterModule,
		SharedModule,
		SwiperModule,
		TabViewModule,
		PaginatorModule,
		TableModule,
		CheckboxModule,
		ToastModule,
		DataViewModule,
		ReactiveFormsModule,
		OverlayPanelModule,
		InputNumberModule,
		FieldsetModule
	],
	declarations: [
		IndexComponent,
		PageNotFoundComponent,
		HumanRecruitComponent,
		SignUpComponent,
		SignInComponent,
		SecondTeamsFormComponent,
		MyAccountComponent,
  SignUpCallbackComponent,
		GroupBreakListComponent,
		GroupBreakDetailComponent,
		MagneticCaseComponent,
	],
	exports: [],
	providers: [],
})
export class PagesModule {}
